import { billOfMaterialsIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const SearchBomResultSchema = z.object({
  id: billOfMaterialsIdFormat.schema,
  name: z.string(),
  tags: z.array(z.string()),
  outputImageUrl: z.string().nullable(),
  outputSku: z.string().nullable(),
  inputSkus: z.array(z.string()),
});

export type SearchBomResult = z.infer<typeof SearchBomResultSchema>;

export const searchBoms = {
  name: "searchBoms" as const,
  input: z.object({
    search: z.string(),
    flowId: z.string(),
    limit: z.number().optional(),
  }),
  output: z.object({ boms: z.array(SearchBomResultSchema) }),
};
